import React from "react";
import { Link } from "react-router-dom";
import "./BlogCard.css";
import { GoArrowUpRight } from "react-icons/go";
import { HiOutlinePencilSquare } from "react-icons/hi2";

const BlogCard = ({ blog, role }) => {
  // Extract first image src from HTML content
  const extractFirstImage = (html) => {
    const match = html.match(/<img[^>]+src="([^">]+)"/);
    return match ? match[1] : "../download.jpg"; // fallback image
  };

  // Strip HTML tags and return plain text
  const extractTextSnippet = (html, maxWords = 7) => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    const text = temp.textContent || "";

    // Split text into words, take first maxWords, join back with spaces
    const words = text.split(/\s+/).filter(Boolean).slice(0, maxWords);
    return words.join(" ") + (words.length === maxWords ? "..." : "");
  };

  const imageUrl = extractFirstImage(blog.content);
  const summary = extractTextSnippet(blog.content);

  return (
    <>
      <Link to={`/blog/${blog._id}`}>
        <div className="blog-card">
          {role === "admin" && (
            <div className="edit">
              <Link
                to={
                  new URL(`/edit-blog/${blog._id}`, window.location.origin)
                    .pathname
                }
                className="edit-button"
              >
                <HiOutlinePencilSquare color="rgb(82 50 8 / 91%)" size={18} />
              </Link>
            </div>
          )}
          <div className="blog-img">
            <img src={imageUrl} className="blog-image" alt={blog.title} />
          </div>
          <div className="p-3 mt-2">
            <h3 className="blog-title">{blog.title}</h3>
            <p className="blog-summary">{summary}</p>
            <div className="blog-info mt-3">
              <span className="blog-date m-0">
                {new Date(blog.createdAt).toLocaleString()}
              </span>
              <Link to={`/blog/${blog._id}`} className="view-button">
                <GoArrowUpRight fontWeight={800} />
              </Link>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default BlogCard;
